import { SplatAction } from "./splat-action.interface";
import { SplatState } from "./splat-state.interface";
import { SplatObject } from "./splat-object.model";

export const SPLAT_ACTIONS: any = {
    UPDATE: "[Splat] Update",
    REMOVE: "[Splat] Remove",
    ADD: "[Splat] Add",
    UPDATE_BACKGROUND: "[Splat] Update Background",
    SET_STATE: "[Splat] Set State"
};

export class RemoveSplatObjectAction implements SplatAction {
    type: string = SPLAT_ACTIONS.REMOVE;
    payload: SplatObject;

    constructor(payload: SplatObject) {
        this.payload = payload;
    }
}

export class AddSplatObjectAction implements SplatAction {
    type: string = SPLAT_ACTIONS.ADD;
    payload: SplatObject;

    constructor(payload: SplatObject) {
        this.payload = payload;
    }
}

export class UpdateSplatObjectAction implements SplatAction {
    type: string = SPLAT_ACTIONS.UPDATE;
    payload: SplatObject;

    constructor(payload: SplatObject) {
        this.payload = payload;
    }
}

export class UpdateBackgroundAction implements SplatAction {
    type: string = SPLAT_ACTIONS.UPDATE_BACKGROUND;
    payload: string;

    constructor(payload: string) {
        this.payload = payload;
    }
}

export class SetStateAction implements SplatAction {
    type: string = SPLAT_ACTIONS.SET_STATE;
    payload: SplatState;

    constructor(payload: SplatState) {
        this.payload = payload;
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/splat/form/lib/splat-actions.ts